import axios from '@/api/$axios'
export default {
  open () {
    return axios.get(`/vips/payed`)
  },
  org () {
    return axios.get(`/vips`)
  },
  list ({ id, related, kw, page, perPage }) {
    const filterKey = {
      videos: 'title',
      courses: 'name'
    }
    const params = { page, perPage }
    params[filterKey[related]] = kw
    return axios.get(`/vips/${id}/${related}`, {
      params
    })
  }
}
